import { Box, TextField, MenuItem, IconButton } from "@mui/material";
import { FieldArray } from "formik";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

const ApplicableTo = ({ values, setFieldValue, jobGrades }) => {
  return (
    <FieldArray
      name="applicableTo"
      render={(arrayHelpers) => (
        <Box display="flex" flexDirection="column" gap={2}>
          {values.applicableTo.map((app, index) => (
            <Box
              key={index}
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gap={2}
              alignItems="center"
            >
              <TextField
                label="Job Grades"
                name={`applicableTo.${index}.jobGrade`}
                select
                fullWidth
                variant="filled"
                value={app.jobGrade || []}
                onChange={(e) =>
                  setFieldValue(`applicableTo.${index}.jobGrade`, e.target.value)
                }
                slotProps={{ select: { multiple: true } }}
                sx={{ gridColumn: "span 5" }}
              >
                {jobGrades.map((r) => (
                  <MenuItem key={r.jobGradeCode} value={r.jobGradeCode}>
                    {r.description || r.jobGradeCode}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                label="Value"
                name={`applicableTo.${index}.value`}
                type="number"
                fullWidth
                variant="filled"
                value={app.value}
                onChange={(e) =>
                  setFieldValue(`applicableTo.${index}.value`, e.target.value)
                }
                slotProps={{
                  input: {
                    sx: {
                      "& input": { textAlign: "right" },
                    },
                  },
                }}
                sx={{ gridColumn: "span 3" }}
              />

              <TextField
                label="Currency"
                name={`applicableTo.${index}.currency`}
                select
                fullWidth
                variant="filled"
                value={app.currency || "VND"}
                onChange={(e) =>
                  setFieldValue(`applicableTo.${index}.currency`, e.target.value)
                }
                sx={{ gridColumn: "span 3" }}
              >
                {["VND", "USD", "EUR", "GBP", "AUD", "JPY", "KRW"].map((cur) => (
                  <MenuItem key={cur} value={cur}>
                    {cur}
                  </MenuItem>
                ))}
              </TextField>

              <Box>
                <IconButton
                  aria-label={`remove-applicable-${index}`}
                  onClick={() => arrayHelpers.remove(index)}
                  size="large"
                  sx={{ gridColumn: "span 1" }}
                >
                  <RemoveCircle />
                </IconButton>
              </Box>              
            </Box>
          ))}

          <Box>
            <IconButton
              aria-label="add-applicable"
              onClick={() =>
                arrayHelpers.push({ jobGrade: [], value: 0, currency: "VND" })
              }
              size="large"
            >
              <AddCircle />
            </IconButton>            
          </Box>
        </Box>
      )}
    />
  );
};

export default ApplicableTo;
